import {
  ADD_KEYWORDS_BY_ENTRY,
  ADD_KEYWORDS_BY_SELECTION,
} from './components/keyword/keyword-methods';
import {
  maxCampaignCount,
  maxExperimentNameLength,
  maxKeywordLength,
  maxSearchCid,
  minSearchCid,
} from './constants/maximums';
import { errorMessages } from './errors';
import { parseKeywordString } from './utils';

export const validateCampaigns = ({ selectedCampaignsById }) => {
  if (selectedCampaignsById == null) {
    return false;
  }

  const campaigns = Object.values(selectedCampaignsById);

  if (campaigns.length === 0) {
    return false;
  }

  return true;
};

export const validateExperimentName = ({ experimentName }) => {
  if (experimentName.length > maxExperimentNameLength) {
    return false;
  }

  if (experimentName.trim().length === 0) {
    return false;
  }

  return true;
};

export const validateStartDate = ({ startDate }) => startDate != null;

export const validateCountry = ({ country }) => country != null;

export const validateMeasurementTypes = ({ useConversionLift, useSearchLift, useVisitLift }) => (
  !!useConversionLift || !!useSearchLift || !!useVisitLift
);

export const validateEnteredKeywordsRequired = ({ typedKeywordString }) => typedKeywordString.trim().length > 0;

export const validateSelectedKeywordsCount = ({ selectedKeywords }) => selectedKeywords.length > 0;

export const validateSearchCid = ({ searchCid }) => {
  if (searchCid.trim().length === 0) {
    return true;
  }

  const value = Number(searchCid);

  if (isNaN(value)) {
    return false;
  }

  if (!Number.isInteger(value)) {
    return false;
  }

  if (value < minSearchCid || value > maxSearchCid) {
    return false;
  }

  return true;
};

export const validateSearchLift = (data) => {
  const {
    keywordsMethod,
    typedKeywordString,
    useSearchLift,
  } = data;

  if (!useSearchLift) {
    return true;
  }

  if (keywordsMethod === ADD_KEYWORDS_BY_ENTRY) {
    if (!validateEnteredKeywordsRequired(data)) {
      return false;
    }

    const parsedKeywords = parseKeywordString(typedKeywordString);
    const tooLongKeywords = parsedKeywords.filter(word => word.length > maxKeywordLength);

    if (tooLongKeywords.length > 0) {
      return false;
    }
  }

  if (keywordsMethod === ADD_KEYWORDS_BY_SELECTION) {
    if (!validateSelectedKeywordsCount(data)) {
      return false;
    }
  }

  if (!validateSearchCid(data)) {
    return false;
  }

  return true;
};

export const validateCampaignCount = ({ count, i18n }) => {
  if (count === 0) {
    return {
      isValid: false,
      error: i18n.getString(errorMessages.CAMPAIGN_REQUIRED),
    };
  } else if (count > maxCampaignCount) {
    return {
      isValid: false,
      error: i18n.getString(errorMessages.CAMPAIGNS_TOO_MANY, { max: maxCampaignCount }),
    };
  }
  return {
    isValid: true,
    error: null,
  };
};

export const validateVisitConversionLift = (data) => {
  const {
    useConversionLift,
    useVisitLift,
    useVisitConversionLift,
    uetTags,
  } = data;

  if (!useVisitConversionLift) {
    return true;
  }

  if (useConversionLift && useVisitLift) {
    return uetTags.both.length !== 0;
  }

  if (useConversionLift) {
    return uetTags.conversion.length !== 0;
  }

  if (useVisitLift) {
    return uetTags.visit.length !== 0;
  }

  return false;
};

const isMeasurementTypeSelected = data => data.useSearchLift || data.useVisitConversionLift;

export const validateLiftExperiment = data => !!data.isValid && isMeasurementTypeSelected(data) && validateVisitConversionLift(data);
